import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const inventoryOrderApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    InvOrderList: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/getinventoryordersuggestions?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    InvOrderById: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/getbyid?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    InvOrders: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    invOrderDelete: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/delete?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    invOrderMarkComplete: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/complete?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    invOrderCreate: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/create`,
        method: "POST",
        body: data,
      }),
    }),
    orderStatusMaster: builder.mutation({
      query: () => ({
        url: `/orderstatusmaster/get`,
        method: "GET",
      }),
    }),
    getOrderItems: builder.mutation({
      query: (data) => ({
        url: `/inventoryorder/orderitems/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    getOrderItemsExport: builder.mutation({
      query: (data) => ({
        url: `inventoryorder/orderitems/export?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    getPurchaseOrder: builder.mutation({
      query: (data) => ({
        url: `/purchaseorder/get?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    purchaseOrderCreate: builder.mutation({
      query: (data) => ({
        url: `/purchaseorder/create`,
        method: "POST",
        body: data,
      }),
    }),
    invPurchaseOrderDelete: builder.mutation({
      query: (data) => ({
        url: `/purchaseorder/delete?${getFilters(data)}`,
        method: "DELETE",
      }),
    }),
    invOrderItemMarkComplete: builder.mutation({
      query: (data) => ({
        url: `/purchaseorder/complete?${getFilters(data)}`,
        method: "PUT",
      }),
    }),
  }),
});
export const {
  useInvOrderListMutation,
  useInvOrdersMutation,
  useInvOrderDeleteMutation,
  useInvOrderMarkCompleteMutation,
  useInvOrderCreateMutation,
  useOrderStatusMasterMutation,
  useInvOrderByIdMutation,
  useGetOrderItemsMutation,
  useGetOrderItemsExportMutation,
  usePurchaseOrderCreateMutation,
  useInvPurchaseOrderDeleteMutation,
  useInvOrderItemMarkCompleteMutation,
  useGetPurchaseOrderMutation
} = inventoryOrderApiSlice;
